import { useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useCallback, useEffect, useState } from "react";
import { languageEnum } from "../../../constants/enum";
import SwitchCustom from "../../../components/switch/SwitchCustom";
import moment from "moment";
import OptionsButtonCustom from "../../../components/option-button/OptionsButtonCustom";
import { alertActive, alertError, alertSuccess } from "../../../components/alert/swal";
import { CourseApi, courseListType, courseType } from "../../../api/course/course.api";
import { useDispatch } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";

export const ManageState = () => {
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [showModal, setShowModal] = useState<string>("");
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(13);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [id_courses, set_id_courses] = useState<number | null>(null);
    const [data, setData] = useState<any[]>([]);
    const [formState, setFormState] = useState<{ subject_no: string, subject_name: string, subject_credit: string }>({
        subject_no: "",
        subject_name: "",
        subject_credit: ""
    })
    const handleChangeFormState = (field: string, value: string) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("")
        setFormState({ subject_credit: "", subject_name: "", subject_no: "" })
        set_id_courses(null);
    }
    const handleShowModal = (mode: string) => {
        setShowModal(mode);
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "subject_no", width: 100, sortable: true, disablePadding: false, align: 'center', label: t("COURSE_MANAGEMENT.COURSE_CODE")
        },
        {
            id: "subject_name", disablePadding: false, width: 240, sortable: true, align: "left", label: t("COURSE_MANAGEMENT.COURSE_NAME")
        },
        {
            id: "subject_credit", disablePadding: false, align: "center", width: 100, label: t("COURSE_MANAGEMENT.COURSE_CREDIT")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("COURSE_MANAGEMENT.COURSE_STATUS")
        },
        {
            id: "create_date", disablePadding: false, align: "center", width: 257, label: t("COURSE_MANAGEMENT.COURSE_CREATE_DATE")
        },
        {
            id: "create_by", disablePadding: false, align: "center", width: 257, label: t("COURSE_MANAGEMENT.COURSE_CREATE_BY")
        },
        {
            id: "s", disablePadding: false, align: "center", width: 100, class: matches, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            courses_no,
            courses_name,
            credits,
            status,
            created_date,
            modified_date,
            id_courses,
            create_name

        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: courses_no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: courses_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: credits || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: <span className='flex justify-center items-center'>
                        <SwitchCustom
                            checked={status === 'active' ? true : false}
                            onChange={(status_data) => handleToggleStatus(id_courses, status_data)}
                        />

                    </span>,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: moment(modified_date || created_date || new Date()).add(543, 'year').format('l') || created_date || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: create_name || "-",
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    width: 300,
                    component: <OptionsButtonCustom
                        enableEdit
                        enableView
                        enableDelete
                        onDeleteClick={() => handleDelete(id_courses)}
                        onEditClick={() => {
                            handleShowModal("EDIT");
                            handleGetOne(id_courses);
                            set_id_courses(id_courses);
                        }}
                        onViewClick={() => {
                            handleShowModal("VIEW");
                            handleGetOne(id_courses);
                            set_id_courses(id_courses)
                            // setFormState({ subject_credit: String(credits || "0"), subject_name: courses_name, subject_no: courses_no })
                        }}

                    />
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDelete = (id_courses: number) => {
        alertActive(t("COURSE_MANAGEMENT.DELETE_COURSE"), t("COURSE_MANAGEMENT.CONFIRM_DELETE_COURSE"), undefined, undefined, async () => {
            dispatch(setLoading());
            await CourseApi.updateStatus(id_courses, { status: 'delete' }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COURSE_MANAGEMENT.DELETE_COURSE"), t("COURSE_MANAGEMENT.DELETE_COURSE_SUCCESS"));
                    handleGetData();
                }
            }).catch((err) => {
                alertError(t("COURSE_MANAGEMENT.DELETE_COURSE"),t("COURSE_MANAGEMENT.DELETE_COURSE_FAILED"))
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleToggleStatus = async (id_courses: number, st: boolean) => {
        const body = {
            status: st ? "active" : "inactive"
        }
        dispatch(setLoading());
        await CourseApi.updateStatus(id_courses, body).then((res) => {
            if (res.status < 300) {
                handleGetData();
            }
        }).catch((err) => {
            console.log(err);
            alertError(t("COURSE_MANAGEMENT.UPDATE_STATUS_FAILED"), t("COURSE_MANAGEMENT.UPDATE_ERROR"))
        }).finally(() => {
            dispatch(unsetLoading())
        })
    }
    const handleSubmit = async () => {
        const body: courseType = {
            courses_name: formState.subject_name,
            courses_no: formState.subject_no,
            credits: formState.subject_credit ? +formState.subject_credit : 0,
            status: "active"
        }
        dispatch(setLoading());
        if (id_courses) {
            await CourseApi.updateOne(id_courses, body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COURSE_MANAGEMENT.UPDATE_COURSE"), t("COURSE_MANAGEMENT.UPDATE_COURSE_SUCCESS"));
                    handleGetData();
                    handleCloseModal();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("COURSE_MANAGEMENT.UPDATE_COURSE"), err?.response?.data?.message || t("COURSE_MANAGEMENT.UPDATE_COURSE_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await CourseApi.create(body).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("COURSE_MANAGEMENT.ADD_COURSE"),t("COURSE_MANAGEMENT.ADD_COURSE_SUCCESS"));
                    handleGetData();
                    handleCloseModal();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("COURSE_MANAGEMENT.ADD_COURSE"), t("COURSE_MANAGEMENT.ADD_COURSE_FAILED"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleGetOne = async (id_courses: number) => {
        dispatch(setLoading());
        await CourseApi.findOne(id_courses).then((res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                setFormState({ subject_credit: String(data?.credits || "0"), subject_name: data?.courses_name, subject_no: data?.courses_no })
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetData = useCallback(async () => {
        let query: courseListType = {
            page: page,
            limit: pageLimit
        }
        if (search) query = { ...query, keyword: search }
        dispatch(setLoading());
        await CourseApi.list(query).then((res) => {
            if (res.status < 300) {
                console.log(res.data)
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, search])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        handleCloseModal,
        showModal,
        handleShowModal,
        handleChangeFormState,
        formState,
        handleSubmit,
        setSearch
    }
}